import type { GraphQLFormattedError } from 'graphql';

import { URL_HIRER_GRAPH_LOCAL } from 'src/constants/urls';
import type { ConfigOptions } from 'src/types';

import { log } from './logging';
export const logGraphQLError = (
  graphQlError: GraphQLFormattedError,
  operationName: any,
  operationMetadata: any,
) => {
  log.error(`GraphQl Error | ${graphQlError.message}`, {
    graphQlError,
    operationName,
    operationMetadata,
  });
};

export const logGraphQLErrorDev = (
  graphQlError: GraphQLFormattedError,
  operationName: any,
  operationMetadata: any,
) => {
  // eslint-disable-next-line no-console
  console.error('graphQlError: ', graphQlError);
  // eslint-disable-next-line no-console
  console.log('operationName: ', operationName);
  // eslint-disable-next-line no-console
  console.log('operationMetadata: ', operationMetadata);

  // On local dev we have a token already, but the GQL queries will fail because the token is invalid
  if (graphQlError?.message?.toLowerCase().indexOf('not logged in') !== -1) {
    throw new Error('Your local auth token is expired.');
  }
};

export const logError = (
  networkError: any,
  operationName: any,
  operationMetadata: any,
) => {
  log.error(`Network Error | ${networkError.message}`, {
    networkError,
    operationName,
    operationMetadata,
  });
};

export const logErrorDev = (
  networkError: any,
  operationName: any,
  operationMetadata: any,
) => {
  // eslint-disable-next-line no-console
  console.error('networkError: ', networkError);
  // eslint-disable-next-line no-console
  console.log('operationName: ', operationName);
  // eslint-disable-next-line no-console
  console.log('operationMetadata: ', operationMetadata);
};

export const getGraphUri = (appConfig: ConfigOptions) => {
  if (appConfig.environment === 'development') {
    return URL_HIRER_GRAPH_LOCAL;
  }
  return '/graphql';
};
